export const version = 'process.env.VERSION';
